import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row gx-5" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "content mb-4" }
const _hoisted_4 = { class: "image mb-4" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "button mb-4"
}
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "row row-text" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row row-link mb-3" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  key: 1,
  class: "row row-button-text-url align-items-center"
}
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "row row-button-target" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "d-inline-block pt-4 border-top border-2 border-light" }
const _hoisted_22 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_text_editor = _resolveComponent("input-text-editor")!
  const _component_input_image = _resolveComponent("input-image")!
  const _component_BaseLinkPicker = _resolveComponent("BaseLinkPicker")!
  const _component_BaseLinkPickerInternalLink = _resolveComponent("BaseLinkPickerInternalLink")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_cb_form = _resolveComponent("cb-form")!

  return (_openBlock(), _createBlock(_component_cb_form, {
    onCopiedLibCb: _ctx.copiedLibContentBlock,
    "cb-type": _ctx.cbType,
    error: _ctx.pageUI.getError(),
    "can-copy-from-library": _ctx.canCopyFromLibrary,
    "is-library": _ctx.isLibrary,
    "is-ready": _ctx.pageUI.isReady(),
    mode: _ctx.currentMode,
    "return-route": _ctx.returnRoute,
    title: _ctx.title ?? null,
    description: _ctx.description,
    description2: _ctx.description2,
    description3: _ctx.description3,
    description4: _ctx.description4
  }, {
    default: _withCtx(() => [
      _createVNode(_component_dp_form, {
        as: "form",
        onSubmit: _ctx.submitData,
        novalidate: ""
      }, {
        default: _withCtx(({ errors }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("section", _hoisted_3, [
                _createVNode(_component_input_text, {
                  label: _ctx.$t('title'),
                  name: "title",
                  modelValue: _ctx.contentBlock.title.nl,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentBlock.title.nl) = $event)),
                  errors: errors
                }, null, 8, ["label", "modelValue", "errors"]),
                _createVNode(_component_input_text_editor, {
                  label: _ctx.$t('content'),
                  name: "content",
                  modelValue: _ctx.contentBlock.content.nl,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.content.nl) = $event)),
                  errors: errors
                }, null, 8, ["label", "modelValue", "errors"])
              ]),
              _createElementVNode("section", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('image')), 1),
                _createVNode(_component_input_image, {
                  modelValue: _ctx.imageKey,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.imageKey) = $event)),
                  id: "logo-file-input",
                  module: _ctx.DpModuleEnum.CMS,
                  typeCode: _ctx.docType
                }, null, 8, ["modelValue", "module", "typeCode"])
              ]),
              (_ctx.hasButtonSection)
                ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                    _createElementVNode("header", _hoisted_7, [
                      _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('button')), 1),
                      (_ctx.hasButton)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearButton && _ctx.clearButton(...args)), ["prevent"])),
                            class: "btn btn-sm btn-icon btn-danger ms-4"
                          }, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.canLinkInternalPage)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_input_text, {
                                label: _ctx.$t('buttonText'),
                                placeholder: "buttonText123",
                                name: "buttonText",
                                modelValue: _ctx.contentBlock.button.button_text.nl,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentBlock.button.button_text.nl) = $event)),
                                errors: errors
                              }, null, 8, ["label", "modelValue", "errors"])
                            ])
                          ]),
                          _createVNode(_component_BaseLinkPicker, {
                            "link-type": _ctx.btnLinkType,
                            onSetLinkType: _ctx.setLinkType
                          }, null, 8, ["link-type", "onSetLinkType"]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              (_ctx.btnLinkType === 'url')
                                ? (_openBlock(), _createBlock(_component_input_text, {
                                    key: 0,
                                    label: _ctx.$t('url'),
                                    name: "buttonUrl",
                                    modelValue: _ctx.contentBlock.button.button_url.nl,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contentBlock.button.button_url.nl) = $event)),
                                    errors: errors
                                  }, null, 8, ["label", "modelValue", "errors"]))
                                : (_ctx.btnLinkType === 'page')
                                  ? (_openBlock(), _createBlock(_component_BaseLinkPickerInternalLink, {
                                      key: 1,
                                      "linked-content-page": _ctx.linkedBtnContentPage,
                                      "has-internal-page-link": _ctx.hasInternalLink,
                                      onClear: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setPageId(null))),
                                      onSet: _ctx.setPageId,
                                      onExceptions: _ctx.setPickerExceptions
                                    }, null, 8, ["linked-content-page", "has-internal-page-link", "onSet", "onExceptions"]))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (!_ctx.canLinkInternalPage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_input_text, {
                              label: _ctx.$t('buttonText'),
                              placeholder: "buttonText456",
                              name: "buttonText",
                              modelValue: _ctx.contentBlock.button.button_text.nl,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contentBlock.button.button_text.nl) = $event)),
                              rules: "both_set:@buttonUrl",
                              errors: errors
                            }, null, 8, ["label", "modelValue", "errors"])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_input_text, {
                              label: _ctx.$t('buttonUrl'),
                              placeholder: "buttonUrl",
                              name: "buttonUrl",
                              modelValue: _ctx.contentBlock.button.button_url.nl,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contentBlock.button.button_url.nl) = $event)),
                              rules: "both_set:@buttonText",
                              errors: errors
                            }, null, 8, ["label", "modelValue", "errors"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_input_select, {
                        class: "col-3",
                        name: "buttonTarget",
                        selectText: _ctx.$t('selectText'),
                        modelValue: _ctx.contentBlock.button.button_target,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contentBlock.button.button_target) = $event)),
                        options: _ctx.extLinkOptions,
                        errors: errors
                      }, null, 8, ["selectText", "modelValue", "options", "errors"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (_ctx.currentMode !== _ctx.PageDetailModeEnum.NEW && (_ctx.isLibrary || _ctx.isNormalContentBlock))
                  ? (_openBlock(), _createBlock(_component_input_number, {
                      key: 0,
                      label: _ctx.$t('sortWeight'),
                      placeholder: "sortWeight",
                      name: "sortWeight",
                      modelValue: _ctx.contentBlock.sort_weight,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contentBlock.sort_weight) = $event)),
                      errors: errors
                    }, null, 8, ["label", "modelValue", "errors"]))
                  : _createCommentVNode("", true),
                (_ctx.isPublishable)
                  ? (_openBlock(), _createBlock(_component_input_select, {
                      key: 1,
                      name: "cbStatus",
                      selectText: _ctx.$t('selectText'),
                      modelValue: _ctx.contentBlock.status_code,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contentBlock.status_code) = $event)),
                      options: _ctx.statusOptions,
                      errors: errors
                    }, null, 8, ["selectText", "modelValue", "options", "errors"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.$t('save')), 1),
                _createVNode(_component_router_link, {
                  to: _ctx.returnRoute ?? {name: 'home'},
                  class: "ms-3 btn btn-outline-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                (_ctx.isClearable)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearContent && _ctx.clearContent(...args)), ["prevent"])),
                      class: "btn btn-outline-danger ms-3"
                    }, _toDisplayString(_ctx.$t('contentClear')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["onCopiedLibCb", "cb-type", "error", "can-copy-from-library", "is-library", "is-ready", "mode", "return-route", "title", "description", "description2", "description3", "description4"]))
}